<template>
  <div id="customers-table">
    <v-data-table
      :items="customers"
      :headers="headers"
      :loading="isLoading"
      class="body-2 elevation-2"
      :options.sync="pagination"
      :footer-props="footerProps"
      @current-items="setCurrentItems"
      :header-props="{ class: 'subtitle-2' }"
      :items-per-page="paginationMeta.itemsPerPage"
      :server-items-length="paginationMeta.serverItemsLength"
      :no-data-text="$dictionary.app.customers.index.noResults"
      :loading-text="$dictionary.app.common.customers.loading"
    >
      <template #item.name="{ item }">
        <router-link
          class="body-2 blue--text text-decoration-none"
          :to="{
            name: 'customer',
            params: { id: item.id },
            query: { active_tab: 'customer_details' },
          }"
        >
          {{ item.name }}
        </router-link>
      </template>
      <template #item.status="{ item }">
        <status-chip :text="item.status" />
      </template>
      <template #item.created_at="{ item }">
        <table-matrics-row :text="item.created_at" />
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { PaginationSortMixin } from "@/mixins";
import { StatusChip } from "@/components/shared";

export default {
  name: "CustomersTable",
  /**
   * --------- Components ------------
   */
  components: {
    StatusChip,
  },
  /**
   * ---------- Data Attributes --------------
   */
  data() {
    return {
      defaultSortOrder: "name",
    };
  },
  /**
   * ---------------- Props ---------------
   */
  props: {
    headers: {
      required: true,
      type: Array,
    },
    customers: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  /**
   * ---------------- Mixins ------------------
   */
  mixins: [PaginationSortMixin],
  /**
   * ---------------- Computed properties ------------------
   */
  computed: {
    /**
     * Server side table pagination config
     * @description {{data}} property (Table component prop) contains an array of records to be shown in the table
     * @type {Object}
     */
    paginationMeta() {
      return {
        itemsPerPage: this.pagination.itemsPerPage || 10,
        serverItemsLength:
          this.pagination.page * this.customers?.length +
          this.pagination.itemsPerPage,
      };
    },
  },
  /**
   * ---------------- Methods -----------------
   */
  methods: {
    /**
     * Sets current items being rendered in the table
     * @emits current-items
     */
    setCurrentItems(items) {
      this.$emit("current-items", [...items]);
    },
  },
  /**
   * ----------- Created Lifecycle --------------
   */
  created() {
    this.getRecords();
  },
};
</script>
